/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Module_Settings_Status_InstalledInputs */



/**
* | output |
* | --- |
* | "Installed" |
*
* @param {Module_Settings_Status_InstalledInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const module_settings_status_installed = /** @type {((inputs?: Module_Settings_Status_InstalledInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Module_Settings_Status_InstalledInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Installed")
	return /** @type {LocalizedString} */ ("Installé")
});